/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gdpr_No_ResultsInputs */

const cs_gdpr_no_results = /** @type {(inputs: Gdpr_No_ResultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nic nenalezeno.`)
};

const en_gdpr_no_results = /** @type {(inputs: Gdpr_No_ResultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nothing found.`)
};

/**
* | output |
* | --- |
* | "Nothing found." |
*
* @param {Gdpr_No_ResultsInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const gdpr_no_results = /** @type {((inputs?: Gdpr_No_ResultsInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gdpr_No_ResultsInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gdpr_no_results(inputs)
	return cs_gdpr_no_results(inputs)
});